import { render, staticRenderFns } from "./OrderItemRow.vue?vue&type=template&id=22fbd73c&scoped=true&"
import script from "./OrderItemRow.vue?vue&type=script&lang=js&"
export * from "./OrderItemRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemRow.vue?vue&type=style&index=0&id=22fbd73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbd73c",
  null
  
)

export default component.exports